<template>
  <div class="btn-foot-wrap">
    <el-button class="confirm-btn" type="primary" @click="submitForm">
      <img class="hot" v-show="isSend" src="@/assets/images/manage/send.png" alt="">
      <img class="hot" v-show="!isSend" src="@/assets/images/manage/comfirm.png" alt="">
      <span>{{$t(`button.confirm`)}}</span>
    </el-button>
    <el-button class="cancel-btn" @click="cancel">
      <img class="hot" src="@/assets/images/manage/cancel.png" alt="">
      <span>{{$t(`button.cancel`)}}</span>
    </el-button>
  </div>
</template>
<script>
export default {
  props: {
    isSend: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submitForm () {
      this.$emit('submitForm')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.el-button {
  position: relative;
  span {
    padding-left: 20px;
  }
  img {
    cursor: pointer;
    position: absolute;
    left: 10px;
    top: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Auth/Btn.vue